// frontend/src/pages/PVList.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function PVList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [role, setRole] = useState("");
  const isMadre = role === "MADRE";

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      // ruolo
      const me = await authFetch(`${API_URL}/api/me/`);
      const meJson = await me.json();
      setRole((meJson?.role || "").toUpperCase());

      const res = await authFetch(`${API_URL}/api/pv/`);
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setItems(Array.isArray(data) ? data : (data.results || []));
    } catch (e) {
      console.error(e);
      setErr("Impossibile caricare i Punti Vendita.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return items;
    return items.filter(
      (r) =>
        (r.code || "").toLowerCase().includes(s) ||
        (r.name || "").toLowerCase().includes(s) ||
        (r.location || "").toLowerCase().includes(s)
    );
  }, [items, q]);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>🏪 Punti Vendita</h3>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
            ← Indietro
          </button>
          {isMadre && (
            <Link to="/pv/nuovo" className="btn btn-primary">+ Nuovo Punto Vendita</Link>
          )}
        </div>
      </div>

      <div className="row g-3 align-items-end mb-3">
        <div className="col-md-6">
          <label className="form-label">Cerca</label>
          <input
            className="form-control"
            placeholder="Codice, Nome o Località…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-outline-primary w-100" onClick={load} disabled={loading}>
            {loading ? "Aggiorno…" : "Aggiorna"}
          </button>
        </div>
      </div>

      {err && <div className="alert alert-danger">{err}</div>}

      <div className="table-responsive">
        <table className="table table-sm table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th style={{width:120}}>Codice</th>
              <th>Nome</th>
              <th>Località</th>
              <th style={{width:120}}></th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted py-4">
                  {loading ? "Caricamento…" : "Nessun punto vendita."}
                </td>
              </tr>
            ) : (
              filtered.map((r) => (
                <tr key={r.id}>
                  <td className="fw-semibold">{r.code}</td>
                  <td>{r.name}</td>
                  <td>{r.location || "—"}</td>
                  <td className="text-end">
                    <Link to={`/pv/${r.id}/edit`} className="btn btn-outline-secondary btn-sm">
                      Modifica
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
